export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/address.8c042aa2.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};